import React from "react";
import ChatWidget from "../ui/ChatWidget";

export default function AppShell({ sidebar, header, children, footer, onNavigate }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: `
          radial-gradient(
            1200px 500px at 50% -250px,
            rgba(110, 86, 207, 0.10),
            transparent 65%
          ),
          #16161f
        `,
        color: "rgb(var(--text))",
      }}
    >
      {header ? header : null}

      <div style={{ flex: 1 }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", padding: "20px 16px" }}>
          <div
            style={{
              display: "grid",
              gap: 16,
              gridTemplateColumns: sidebar ? "260px 1fr" : "1fr",
            }}
          >
            {sidebar ? (
              <aside className="card" style={{ padding: 14, alignSelf: "start" }}>
                {sidebar}
              </aside>
            ) : null}

            <main>{children}</main>
          </div>
        </div>
      </div>

      {footer ? (
        <footer className="app-footer">
          <div className="footer-inner">
            {footer}
          </div>
        </footer>
      ) : null}

      <ChatWidget onNavigate={onNavigate} />
    </div>
  );
}
